export const hubspotModal = {
    state: {
        open: false,
        tag: "",
    },
    reducers: {
        toggleModal(state, payload) {
            return {
                ...state,
                open: payload,
            }
        },
        setHubspotTag(state, payload) {
            return {
                ...state,
                tag: payload,
            }
        },
    },
}
